import { formatCurrencyFromMicros, formatInteger, formatPlatform } from '../constants';

export function TopCampaignsTable({ campaigns = [] }) {
  return (
    <section className="rounded-2xl border border-mystic-500 bg-white p-5 shadow-sm">
      <div className="flex items-center justify-between gap-4">
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.14em] text-lynch-500">Top Campaigns</p>
          <h2 className="mt-2 text-lg font-semibold text-black-pearl-500">Highest spend in the current range</h2>
        </div>
      </div>
      {campaigns.length === 0 ? (
        <p className="mt-6 text-sm text-lynch-500">No campaigns have reported spend for the selected range yet.</p>
      ) : (
        <div className="mt-6 overflow-x-auto">
          <table className="min-w-full divide-y divide-mystic-500 text-left text-sm">
            <thead>
              <tr className="text-xs font-semibold uppercase tracking-[0.12em] text-lynch-500">
                <th className="pb-3 pr-4">Campaign</th>
                <th className="pb-3 pr-4">Platform</th>
                <th className="pb-3 pr-4">Spend</th>
                <th className="pb-3 pr-4">Clicks</th>
                <th className="pb-3">Impressions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-solitude-500">
              {campaigns.map((campaign) => (
                <tr key={campaign.id}>
                  <td className="py-3 pr-4 font-medium text-black-pearl-500">{campaign.name}</td>
                  <td className="py-3 pr-4 text-lynch-500">{formatPlatform(campaign.platform)}</td>
                  <td className="py-3 pr-4 text-black-pearl-500">{formatCurrencyFromMicros(campaign.spendMicros)}</td>
                  <td className="py-3 pr-4 text-black-pearl-500">{formatInteger(campaign.clicks)}</td>
                  <td className="py-3 text-black-pearl-500">{formatInteger(campaign.impressions)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
}
